import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import ListSubheader from '@mui/material/ListSubheader';

import LockIcon from 'app/assets/icons/lock3.svg?react';
import FuseNavItem from '../../FuseNavItem';


const Root = styled(ListSubheader)(({ theme, itempadding, ...props }) => ({
  height: 40,
  width: '100%',
  borderRadius: '6px',
  margin: '16px 0 0 0',
  paddingRight: 12,
  paddingLeft: props.itempadding > 80 ? 80 : props.itempadding,
  lineHeight: 20,
}));

function FuseNavVerticalGroup(props) {
  const { item, nestedLevel, onItemClick } = props;

  const itempadding = nestedLevel > 0 ? 28 + nestedLevel * 16 : 12;

  return useMemo(
    () => (
      <>
        <Root
          component={item.url ? NavLinkAdapter : 'li'}
          itempadding={itempadding}
          disableSticky
          className={clsx(
            'fuse-list-subheader flex items-center justify-between',
            !item.url && 'cursor-default'
          )}
          onClick={() => onItemClick && onItemClick(item)}
          to={item.url}
          end={item.end}
          role="button"
        >
          <span
            className={clsx('fuse-list-subheader-text text-12', item.featured ? 'text-featured-title' : 'text-grey-A100')}
          >{item.title}</span>
          {item.locked && <LockIcon className="h-16 w-16 text-border-danger" />}
        </Root>
        {item.children && (
          <>
            {item.children.map((_item) => (
              <FuseNavItem
                key={_item.id}
                type={`vertical-${_item.type}`}
                item={_item}
                nestedLevel={nestedLevel}
                onItemClick={onItemClick}
              />
            ))}
          </>
        )}
      </>
    ),
    [item, itempadding, nestedLevel, onItemClick]
  );
}

FuseNavVerticalGroup.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    children: PropTypes.array,
  }),
};

const NavVerticalGroup = FuseNavVerticalGroup;

export default NavVerticalGroup;
